import { AfterContentInit, Directive, Input, OnDestroy, TemplateRef } from '@angular/core';
import { MatMenuPanel } from '@angular/material/menu';
import { SgTopNavElement, SgTopNavService } from './top-nav.service';

@Directive({
  selector: '[sgTopNavElement]',
  standalone: false,
})
export class SgTopNavElementDirective implements AfterContentInit, OnDestroy, SgTopNavElement {
  @Input('sgTopNavElement') type!: 'header' | 'rElement' | 'vertMenuElement';
  @Input('sgTopNavElementMenuTriggerFor') menuTriggerFor!: MatMenuPanel;
  @Input('sgTopNavElementVertMenuType') vertMenuType!: 'button' | 'menuButton' | 'element';

  constructor(
    public templateRef: TemplateRef<any>,
    private topNavService: SgTopNavService
  ) {}

  ngAfterContentInit(): void {
    this.topNavService.addElement(this);
  }

  ngOnDestroy(): void {
    this.topNavService.removeElement(this);
  }
}
